import { FC, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useDebounce } from '../../scripts/hooks/useDebounce';
import { InStreamVideoContext } from './instreamVideoContext';

type TVenatusRichMediaProps = {
  instreamUnitId: string;
  outstreamUnitId: string;
  delayBeforeAssessmentMs: number;
};

type TVenatusRichMediaPlacementProps = {
  name: string;
  unitId: string;
};

const VenatusRichMediaPlacement: FC<TVenatusRichMediaPlacementProps> = (props) => {
  const adRef = useRef(null);
  useEffect(() => {
    if (adRef.current) {
      const addQueue = ((window as any).__vm_add = (window as any).__vm_add || []);
      addQueue.push(adRef.current);

      // console.info(`[VENATUS] [RICHMEDIA] adding id ${props.unitId} (${props.name})`);
    }
  }, [props.unitId]);
  return <div ref={adRef} className="vm-placement" data-id={props.unitId} />;
};

let lastLoggedState: string = '';
const VenatusRichMedia: FC<TVenatusRichMediaProps> = (props) => {
  const location = useLocation();
  const { isInStream } = useContext(InStreamVideoContext);
  const debouncedLocation = useDebounce(location, props.delayBeforeAssessmentMs);

  useEffect(() => {
    return () => {
      // remove all richmedia whenever page changes
      // console.info('[VENATUS] [RICHMEDIA] removing all richmedia');
      (window as any).__vm_remove_category = (window as any).__vm_remove_category || [];
      (window as any).__vm_remove_category.push('richmedia_all');
      lastLoggedState = '';
    };
  }, [location]);

  // JR we cannot force instream by path because the div may not be present on page yet
  // so we have to wait until the div is actually there before we consider it instream
  // const strippedPath = stripPathLocale(location.pathname);
  const isForcedInStream = false; // isForcedInStreamPath(strippedPath);

  if (location !== debouncedLocation && !isForcedInStream) {
    // during change from one page to another we want to ensure no rich media shows
    // console.info('[VENATUS] [RICHMEDIA] returning NULL (waiting for tag)');
    lastLoggedState = '';
    return null;
  }

  // TODO: do we need to do something to restrict what pages takeovers are allowed on?
  if (isInStream || isForcedInStream) {
    if (lastLoggedState !== 'instream') {
      // console.info(`[VENATUS] [RICHMEDIA] returning INSTREAM forced=${isForcedInStream} #vm-av=`, document?.getElementById('vm-av'));
      lastLoggedState = 'instream';
    }
    return <VenatusRichMediaPlacement name="instream" unitId={props.instreamUnitId} />;
  } else {
    if (lastLoggedState !== 'outstream') {
      // console.info('[VENATUS] [RICHMEDIA] returning OUTSTREAM #vm-av=', document?.getElementById('vm-av'));
      lastLoggedState = 'outstream';
    }
    return <VenatusRichMediaPlacement name="outstream" unitId={props.outstreamUnitId} />;
  }
};

export default VenatusRichMedia;
